
// const AppComponent = () => System.import("views/vcponlineok/app/App.vue")
export const errorRouters = [
  {
    path: "/error",
    name: "error",
    meta: { title: "Error" },
    component: () => System.import("views/vcponlineok/error/error-view.vue"),
    children: [
        {
            path: "403",
            name: "error-403",
            meta: {
              title:"Error",
              isPublic: true,
            },
            component: () => System.import("views/vcponlineok/error/error403-view.vue"),
          }
    ],
  },
]
